var exports = {
  "NJ": "shimmerText__MTecuE",
  "qG": "fadeIn__6pyTmq",
};

module.exports = exports;
